/*
 * @Date: 2025-06-22 14:05:53
 * @LastEditors: lifangdi
 * @LastEditTime: 2025-07-04 21:14:07
 */
import React, { useEffect, useState } from "react";
import styled from "styled-components";

const CookieBanner = styled.div`
  position: fixed;
  bottom: 0.3rem;
  right: 0.3rem;
  background: #000;
  color: #fff;
  padding: 0.3rem;
  width: 4.6rem;
  z-index: 9999;
  font-size: 0.18rem;
  font-weight: 500;
  line-height: 0.22rem;
  font-family: "neue-haas-grotesk-text", sans-serif;
  @media (max-width: 768px) {
    top: auto;
    right: 0.2rem;
    left: 0.2rem;
    bottom: 0.64rem;
    width: calc(100% - 0.4rem);
    padding: 0.2rem;
    font-size: 0.12rem;
    line-height: 0.16rem;
  }
`;

const PrivacyLink = styled.a`
  color: #fff;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }
`;

const OkButton = styled.button`
  margin-top: 0.9rem;
  background: #fff;
  font-family: "neue-haas-grotesk-text", sans-serif;
  font-size: 0.18rem;
  font-weight: 500;
  line-height: 0.22rem;
  color: #181818;
  border: none;
  padding: 0.05rem;
  cursor: pointer;
  float: right;
  @media (max-width: 768px) {
    font-size: 0.12rem;
    line-height: 0.16rem;
    margin-top: 0.6rem;
  }
`;

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleOk = () => {
    localStorage.setItem("cookieConsent", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <CookieBanner>
      <p>
        We use cookies to understand how you use our site and to improve your
        experience. This includes personalizing content. By continuing to use
        our site, you accept our use of cookies, revised{" "}
        <PrivacyLink href="/privacy">Privacy</PrivacyLink>.
      </p>
      <OkButton onClick={handleOk}>OK</OkButton>
    </CookieBanner>
  );
};

export default CookieConsent;
